import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=5934fc71&scoped=true&"
import script from "./checkBox.vue?vue&type=script&lang=ts&"
export * from "./checkBox.vue?vue&type=script&lang=ts&"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=5934fc71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934fc71",
  null
  
)

export default component.exports